import React from 'react';
import './MobileView.css';

const MobileView = () => {
  return (
    <div className="mobile-view-container">
      <div className="mobile-view-content">
        <i className="fas fa-desktop mobile-icon"></i>
        <h1>Desktop Only</h1>
        <p>Please use a desktop device to access this application.</p>
        <p>Mobile view is not supported at this time.</p>
      </div>
    </div>
  );
};

export default MobileView; 